module.exports = __webpack_public_path__ + "media/assets/socialmedia-21f292ab6fa9251e99a7b79b136d0051.jpg";